import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useMeters} from '../hooks/useMeters.ts';

export const ReloadRecordsButton = () => {

    const {fetchRecords} = useMeters();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};